import type { KeywordTrendsSchema } from "app/pages/activation/types/api";

export function sumTrendsFields(
    schema: KeywordTrendsSchema,
    keys: (keyof KeywordTrendsSchema)[],
): number {
    return keys.reduce((sum, key) => sum + (schema[key] ?? 0), 0);
}
